import { render } from "./SelectAccessModule.vue?vue&type=template&id=302ba1e4&scoped=true&ts=true"
import script from "./SelectAccessModule.vue?vue&type=script&lang=ts"
export * from "./SelectAccessModule.vue?vue&type=script&lang=ts"

import "./SelectAccessModule.vue?vue&type=style&index=0&id=302ba1e4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302ba1e4"]])

export default __exports__